// Angular
import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// Libraries




// Afidium
import { Yii } from 'libraries/interfaces/Yii';

@Component({
    selector: 'back-button',
    template: `<btn [label]="wording.goBack" (click)="goBack()" type="actionHeaderLink"></btn>`
})
export class BackButtonComponent  {
    public wording = {
        goBack: Yii.t('wui-sasha-js', 'Abandonner')
    };

    public constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
    ) {}

    public goBack(){
        const previous = this.activatedRoute.snapshot.queryParams.previousRoute || '/sasha/home';
        this.router.navigateByUrl(previous);
    }
}